import { get, del, post } from './requests.js'
import { v4 as uuidv4 } from 'uuid'

export const newLog = (data) =>
  post(['logs'], { transformPayload: true }, { name: uuidv4(), ...data })

export const getLogs = (params) => get(['logs'], { transformPayload: true }, params)

export const deleteLog = (id) => del(['logs', id], { transformPayload: true })

export const getLogsEnum = (field) => get(['logs', 'enum', field], { transformPayload: true })
